<div class="lead-form-info" *ngIf="entity">
    <div class="row">
        <div class="form-group col-12">
            <h5 class="lead-nome">{{entity.nome}}</h5>
            <p class="lead-nome-fantasia">{{entity.nomeFantasia}}</p>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12">
            <label class="col-form-label">Origem</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="{{entity.origem | origemIcon}}"></i>
                    </span>
                </div>
                <input type="text" disabled readonly class="form-control" value="{{entity.origem | origem}}">
            </div>
        </div>
    </div>

    <div class="row" *ngIf="config?.isOrigemPossuiCanalVenda">
        <!-- Canal de Venda de Origem -->
        <div class="form-group col-12">
            <label class="col-form-label">Canal de Venda de Origem</label>
            <sgt-canal-venda-input-group
                [canalVenda]="entity.canalVendaOrigem">
            </sgt-canal-venda-input-group>
            <p class="form-text text-muted">
                Canal de venda que originou este lead
            </p>
        </div>
    </div>

    <div class="row" *ngIf="config?.isOrigemCampanha">
        <div class="form-group col-12">
            <label class="col-form-label">Campanha de Origem</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.campanhaOrigem?.nome">
        </div>
    </div>

    <div class="row" *ngIf="entity.idCampanhaQualificacao">
        <div class="form-group col-12">
            <label class="col-form-label">Campanha de Qualificação</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.campanhaQualificacao?.nome">
        </div>
    </div>

    <div class="row" *ngIf="config?.isOrigemMidiaSocial">
        <div class="form-group col-12">
            <label class="col-form-label">Canal da Mídia Social</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="{{entity.canalMidiaSocial | canalMidiaSocialIcon}}"></i>
                    </span>
                </div>
                <input type="text" disabled readonly class="form-control" value="{{entity.canalMidiaSocial | canalMidiaSocial}}">
            </div>
        </div>
    </div>

    <div class="row">
        <div class="form-group col-12">
            <label class="col-form-label"><i class="fas fa-user"></i> Contato</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.contatoPrincipal?.nome">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12 col-md">
            <label class="col-form-label"><i class="fas fa-phone-alt"></i> Telefone</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.contatoPrincipal?.fone">
        </div>
        <div class="form-group col-12 col-md">
            <label class="col-form-label"><i class="fas fa-mobile-alt"></i> Celular</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.contatoPrincipal?.celular">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12">
            <label class="col-form-label"><i class="far fa-envelope"></i> E-mail</label>
            <input type="text" disabled readonly class="form-control" [value]="entity.contatoPrincipal?.email">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12">
            <label class="col-form-label"><i class="fas fa-map-marker-alt"></i> Cidade</label>
            <input type="text" disabled readonly class="form-control" value="{{entity.enderecoPrincipal?.cidade?.nome}} - {{entity.enderecoPrincipal?.cidade?.estado?.uf}}">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12">
            <label class="col-form-label"><i class="fas fa-pen-alt"></i> Anotação</label>
            <textarea class="form-control" disabled readonly sgtAutosize>{{entity.anotacao}}</textarea>
        </div>
    </div>

    <!-- Outros Contatos -->
    <sgt-collapse-group title="Outros Contatos" [isCollapsedInDefault]="false" *ngIf="entity.outrosContatos && entity.outrosContatos.length > 0">
        <sgt-lead-contato-list-group
            [contatos]="entity.outrosContatos"
            [canOpen]="false">
        </sgt-lead-contato-list-group>
    </sgt-collapse-group>

    <!-- Identificação -->
    <sgt-collapse-group title="Identificação" [isCollapsedInDefault]="false">
        <div class="row">
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Tipo</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.tipoPessoa | pessoaTipo">
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12 col-md">
                <label class="col-form-label">{{entity.tipoPessoa | pessoaTipoAbreviacao}}</label>
                <div class="input-group">
                    <div class="input-group-prepend" *ngIf="entity.identificadorMatrizFilial">
                        <sgt-identificador-matriz-filial-input-group-text
                            [identificador]="entity.identificadorMatrizFilial"
                            [prepend]="true">
                        </sgt-identificador-matriz-filial-input-group-text>
                    </div>
                    <input type="text" disabled readonly class="form-control" [value]="entity.cnpjCpf">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-md">
                <label for="dataFundacao" class="col-form-label">
                    <span *ngIf="config?.isTipoPessoaFisica">Data de Nascimento</span>
                    <span *ngIf="!config?.isTipoPessoaFisica">Data de Abertura</span>
                </label>
                <input type="text" disabled readonly class="form-control" value="{{entity.dataFundacao | date: 'dd/MM/yyyy'}}">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <sgt-porte-empresa-form-control
                    [codigo]="entity.porteEmpresaCodigo"
                    [nome]="entity.porteEmpresaNome">
                </sgt-porte-empresa-form-control>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <sgt-natureza-juridica-form-control
                    [codigo]="entity.naturezaJuridicaCodigo"
                    [nome]="entity.naturezaJuridicaNome">
                </sgt-natureza-juridica-form-control>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Periodicidade de Compra</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.periodicidadeCompra?.nome">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Segmentos</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.classificacoesNome">
            </div>
        </div>
    </sgt-collapse-group>


    <!-- Endereço -->
    <sgt-collapse-group title="Endereço" [isCollapsedInDefault]="false">
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">CEP</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.enderecoPrincipal?.cep">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Logradouro</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.enderecoPrincipal?.logradouro">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-md-4">
                <label class="col-form-label">Número</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.enderecoPrincipal?.numero">
            </div>
            <div class="form-group col-12 col-md">
                <label class="col-form-label">Bairro</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.enderecoPrincipal?.bairro">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Complemento</label>
                <input type="text" disabled readonly class="form-control" [value]="entity.enderecoPrincipal?.complemento">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label class="col-form-label">Cidade</label>
                <input type="text" disabled readonly class="form-control" value="{{entity.enderecoPrincipal?.cidade?.nome}} - {{entity.enderecoPrincipal?.cidade?.estado?.uf}}">
            </div>
        </div>
    </sgt-collapse-group>

    <!-- Simples Nacional -->
    <sgt-collapse-group title="Simples Nacional" [isCollapsedInDefault]="false" *ngIf="config?.isTipoPessoaJuridica">
        <div class="row">
            <div class="form-group col-12">
                <sgt-simples-nacional-form
                    #simplesNacionalForm
                    [canEdit]="false"
                    [entity]="entity"
                    [isMini]="true">
                </sgt-simples-nacional-form>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <sgt-mei-form
                    #meiForm
                    [canEdit]="false"
                    [entity]="entity"
                    [isMini]="false">
                </sgt-mei-form>
            </div>
        </div>
    </sgt-collapse-group>

    <!-- CNAEs e QSA -->
    <sgt-collapse-group title="CNAEs e QSA" [isCollapsedInDefault]="false">
        <div class="row">
            <div class="form-group col-12">
                <sgt-cnaes-view
                    [cnaePrincipal]="entity.cnaePrincipal"
                    [cnaesSecundarias]="entity.cnaesSecundarias | cnaeSecundariasViewerMap">
                </sgt-cnaes-view>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12">
                <sgt-capital-social-form-control-text
                    [capitalSocial]="entity.capitalSocial">
                </sgt-capital-social-form-control-text>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12">
                <sgt-socio-view
                    [socios]="entity.socios">
                </sgt-socio-view>
            </div>
        </div>
    </sgt-collapse-group>
</div>
